import { Component, OnInit, Input } from '@angular/core';
import { theme } from 'src/environments/theme';
import { CvBox } from '../shared/models/cv-box-model';
import { UserTypeEnum } from '@hrra/common-models';
import { EnvService } from '@hrra/core';

@Component({
    selector: 'app-cv-box-item',
    templateUrl: `./${theme.name}/cv-box-item.component.html`,
    styleUrls: [`./${theme.name}/cv-box-item.component.scss`],
    standalone: false
})
export class CvBoxItemComponent implements OnInit {

  @Input() cvBox: CvBox;
  @Input() userType: UserTypeEnum;
  isLogoWitBackground = true;
  providerWebsiteId: number

  userTypeEnum: any;
  
  constructor(private envService: EnvService) { 
    this.userTypeEnum = UserTypeEnum;
  }

  ngOnInit(){
    this.providerWebsiteId = this.envService.tenantId
  }

}
